module.exports = __webpack_public_path__ + "static/img/blurred-background-mobile.c6b029a.jpg";